import { useEffect, useState } from "react";
import ApiService from "../../Service/ApiService"; //Assuming your file is in a file called ApiService.js
import BookingItem from "./BookingItem";
import "./index.css";

const FindBookingPage = () => {
  const [confirmationCode, setConfirmationCode] = useState(""); // State variable for confirmation code
  const [bookingDetails, setBookingDetails] = useState(null); // state variable for booking details
  const [error, setError] = useState(null); //track any errors
  const [myBookings, setMyBookings] = useState([]);

  const fetchMyBookings = async () => {
    const userProfile = await ApiService.getUserProfile();
    if (userProfile) {
      const userId = userProfile.id;
      const bookings = await ApiService.getUserBookings(userId);
      setMyBookings(bookings.bookings ?? []);
      setBookingDetails(null); // clear booking details when fetching my bookings
      setError(null); // clear any previous errors
    }
  };

  useEffect(() => {
    fetchMyBookings();
  }, []);

  const handleSearch = async () => {
    if (!confirmationCode.trim()) {
      setError("Please enter a booking confirmation code");
      await fetchMyBookings();
      setTimeout(() => setError(""), 2000);
      return;
    }
    const response = await ApiService.getBookingByConfirmationCode(
      confirmationCode
    );
    setBookingDetails(response);
    setError(null); //clear error if successful
    setMyBookings([]); // clear my bookings when searching by confirmation code
  };
  return (
    <div className="find-booking-page">
      <h2>Find Booking</h2>
      <div className="search-container">
        <input
          required
          type="text"
          placeholder="Enter your booking confirmation code"
          value={confirmationCode}
          onChange={(e) => setConfirmationCode(e.target.value)}
        />
        <button onClick={handleSearch}>Find</button>
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div className="find-booking-results">
        {bookingDetails && (
          <BookingItem
            key={bookingDetails.id}
            bookingDetails={bookingDetails}
          />
        )}
        {myBookings.length > 0 && <h3>My Bookings</h3>}
        {myBookings.length > 0 &&
          myBookings.map((booking, idx) => {
            return <BookingItem key={idx} bookingDetails={booking} />;
          })}
      </div>
    </div>
  );
};

export default FindBookingPage;
